/**
 * Polska odmiana rzeczownika po liczebniku: 1 zlecenie, 2–4 zlecenia,
 * 5–21 zleceń, 22–24 zlecenia, 25 zleceń… „1 zleceń” w interfejsie wygląda
 * na błąd programu, nie na liczbę.
 */
export function plural(n: number, one: string, few: string, many: string): string {
  return `${n} ${pluralWord(n, one, few, many)}`;
}

/**
 * Sam rzeczownik w formie dla liczby — gdy liczbę trzeba sformatować
 * inaczej („7 003 zlecenia” z separatorem tysięcy).
 */
export function pluralWord(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  if (abs === 1) return one;
  const lastTwo = abs % 100;
  const last = abs % 10;
  if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return few;
  return many;
}

/** To samo co `pluralWord` — druga nazwa z równoległej poprawki (07.10.2026). */
export const pluralNoun = pluralWord;
